// 涉及到的类型
// import type { FileNode } from '@tencent/docs-drive-selector';

type FileNode = any;

export enum InsertDocType {
    // 附件
    Attachment = 'attachment',
    // 腾讯文档所有的文件类型
    File = 'file',
}

interface AttachmentInfo {
    objKey: string;
    filetype: string;
    size: string;
    classify: string;
    name: string;
}

export type InsertDocFileNode = FileNode & { type: InsertDocType };
export type InsertDocAttachmentInfo = AttachmentInfo & { type: InsertDocType };

/**
 * 在线文件选择器配置信息
 */
export interface FileSelectorConfig {
    /**
     * 展示的tab数
     */
    tabs?: string[];
    /**
     * 文件选择器标题
     */
    title?: string;

    /**
     * 最大可选数量
     *
     * @default 9
     */
    maxNumber?: number;

    /**
     * 查询 mimeType 符合该参数的项，不传或传空数组表示查询所有 mimeType 的结果
     */
    mimeTypes?: TencentDocMimeType[];

    /**
     * 点击确认、取消、关闭按钮，或有错误发生时，是否自动关闭文件选择器
     * @default true
     */
    autoClose?: boolean;

    /**
     * 确定按钮配置
     */
    confirmButtonConfig?: ConfirmButtonConfig;

    /**
     * 处理选择完文件的回调函数
     */
    onConfirm?: (FileNode: (InsertDocFileNode | InsertDocAttachmentInfo | null)[]) => Promise<void>;

    /**
     * 品类的 padId
     */
    hostFileId?: string;
}

export interface ConfirmButtonConfig {
    /**
     * 点击确认按钮回调
     * @param 已选择的文件
     */
    onClick: (result: any[]) => void;
}

/* 腾讯文档不同品类的 mimeType */
export enum TencentDocMimeType {
    /** 文件夹 */
    TecentFolder = 'application/vnd.tdocs-apps.folder',
    /** Slide 幻灯片 */
    TencentSlide = 'application/vnd.tdocs-apps.slide',
}
